export default __webpack_public_path__ + "static/media/background_2.136a5060.jpg";